import restApi from "@plannel/services/utils/rest-api";

const get = params => {
  return restApi.post("/api/bf-feature-date", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/bf-feature-date/csv", params);
};

const upsert = data => {
  return restApi.post("/api/bf-feature-date/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/bf-feature-date/${ids}`);
};

const bfFeatureDateService = {
  get,
  getAllForCSV,
  upsert,
  remove,
};

export default bfFeatureDateService;
